var React = require('react');

function Link (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M27.295 5.454c.73.303 1.391.746 1.949 1.306a5.999 5.999 0 01.02 8.478l-7.999 7.998a5.997 5.997 0 01-4.269 1.76 5.999 5.999 0 01-4.249-1.73 5.998 5.998 0 010-8.498l1.42-1.42 1.41 1.42-1.41 1.42a4.005 4.005 0 105.669 5.658l7.998-7.998a4.01 4.01 0 00-5.669-5.669l-1.42-1.42a5.998 5.998 0 016.55-1.305zM3.318 23.516c.202.487.498.928.871 1.3a3.997 3.997 0 005.669 0l1.42 1.42a6.069 6.069 0 01-4.28 1.759 5.999 5.999 0 01-4.258-1.7 5.999 5.999 0 010-8.508l7.998-7.998a6.016 6.016 0 118.508 8.508l-2.12 2.12-1.42-1.42 2.12-2.15a4 4 0 001.17-2.849 3.938 3.938 0 00-2.44-3.72 4 4 0 00-4.369.87L4.19 19.148a4 4 0 00-.871 4.37z","key":1})]);
}

Link.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Link;

Link.default = Link;
